import { Component, Inject } from '@angular/core';

import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-allowed',
  standalone: false,
  templateUrl: './allowed.component.html',
  styleUrl: './allowed.component.scss'
})


export class AllowedComponent {
   
  public data: AllowedChangesDialogData;

  public constructor(
  @Inject(MAT_DIALOG_DATA) data: AllowedChangesDialogData,
  ) {
    this.data = data;
  }

  
  getDisplayName(fileName: string): string {
  return fileName.replace(/\.csv$/i, '');
}
}

export interface AllowedChangesDialogData {
  name:any
  onLeave: () => void;
  onStay: () => void;


}
